module.exports = __webpack_public_path__ + "img/img2.696060f9.png";